const initialState = {
  meta: {
  },
  settings: {
  },
  status: {
    activesection: -1,
    isloading: true,
    isfullscreen: false
  }
}

const CommonReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_ALL':
      return Object.assign({}, {
        ...state,
        meta: action.value.meta
      })
    case 'START_LOADING':
      return Object.assign({}, {
        ...state,
        status: {
          ...state.status,
          isloading: true
        }
      })
    case 'END_LOADING':
      return Object.assign({}, {
        ...state,
        status: {
          ...state.status,
          isloading: false
        }
      })
    case 'LOAD_OBJECTS':
      return Object.assign({}, {
        ...state,
        objects: action.value
      })
    case 'UPDATE_META':
      return Object.assign({}, {
        ...state,
        meta: action.value
      })
    case 'UPDATE_ACTIVESECTION':
      return Object.assign({}, {
        ...state,
        status: {
          ...state.status,
          activesection: state.activesection === action.value ? state.activesection : action.value
        }
      })
    default:
      return state
  }
}

export default CommonReducer
